import React, { useEffect } from 'react';
import { Icon, addIcon, addCollection } from '@iconify/react';

// Import icon collections
import simpleIconsData from '@iconify-json/simple-icons/icons.json';
import tablerData from '@iconify-json/tabler/icons.json';
import ionData from '@iconify-json/ion/icons.json';
import biData from '@iconify-json/bi/icons.json';
import mdiData from '@iconify-json/mdi/icons.json';
import riData from '@iconify-json/ri/icons.json';

// Load all collections on module load
(() => {
  // Add Simple Icons
  addCollection({
    prefix: 'simple-icons',
    icons: simpleIconsData.icons as any,
    width: (simpleIconsData as any).width || 24,
    height: (simpleIconsData as any).height || 24,
  });

  // Add Tabler Icons
  addCollection({
    prefix: 'tabler',
    icons: tablerData.icons as any,
    width: (tablerData as any).width || 24,
    height: (tablerData as any).height || 24,
  });

  // Add Ion Icons
  addCollection({
    prefix: 'ion',
    icons: ionData.icons as any,
    width: (ionData as any).width || 512,
    height: (ionData as any).height || 512,
  });

  // Add Bootstrap Icons
  addCollection({
    prefix: 'bi',
    icons: biData.icons as any,
    width: (biData as any).width || 16,
    height: (biData as any).height || 16,
  });

  // Add Material Design Icons
  addCollection({
    prefix: 'mdi',
    icons: mdiData.icons as any,
    width: (mdiData as any).width || 24,
    height: (mdiData as any).height || 24,
  });

  // Add Remix Icons
  addCollection({
    prefix: 'ri',
    icons: riData.icons as any,
    width: (riData as any).width || 24,
    height: (riData as any).height || 24,
  });

  console.log('[Iconify] Loaded offline collections at module level');
})();

interface OfflineIconProps {
  icon: string;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

// Wrapper component that ensures offline mode
export const OfflineIcon: React.FC<OfflineIconProps> = ({ icon, ...props }) => {
  return <Icon icon={icon} {...props} />;
};

export default OfflineIcon;
